import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const TopicHeaderContent = styled(FlexRow)`
    width: 100%;
    justify-content: space-between;
`;

const TopicHeaderTitles = styled(FlexRow)`
    gap: 16px;
    align-items: center;
`;

const TopicHeaderButtons = styled(FlexRow)`
    gap: 16px;
`;

export const StyledSuggestionSubtitle = styled(FlexRow)`
    gap: 8px;
    align-items: center;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
`;

export const StyledNumber = styled(FlexRow)`
    ${setFontVariant("input2", colorsPalettes.carbon[250])};

    align-items: center;
    margin-right: 15px;
`;

export const StyledButtonGroup = styled(FlexRow)`
    justify-content: center;
    margin-left: auto;
    margin-right: -32px;

    button {
        padding: 8px 16px;
    }
`;
